import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CreditCard, Clock } from 'lucide-react';

const MembershipPaymentPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r from-orange-500 to-yellow-500 mb-4">
            <CreditCard className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Üyelik Yenileme</h1>
          <p className="text-slate-400">HIMS Usta Portal</p>
        </div>

        {/* Content Card */}
        <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700 p-8">
          <div className="text-center py-8">
            <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-orange-500/20 flex items-center justify-center">
              <Clock className="w-10 h-10 text-orange-500" />
            </div>
            <h2 className="text-xl font-semibold text-white mb-2">Yakında Aktif Olacak</h2>
            <p className="text-slate-400 mb-6">
              Ödeme sistemi şu anda hazırlanıyor. 
              Kısa süre içinde üyeliğinizi yenileyebileceksiniz.
            </p>
            
            <div className="bg-slate-900/50 rounded-xl p-4 mb-6">
              <p className="text-sm text-slate-500 mb-2">Yıllık Üyelik Ücreti</p>
              <p className="text-3xl font-bold text-white">1.200 ₺</p>
              <p className="text-xs text-slate-500 mt-1">KDV Dahil</p>
            </div>

            <p className="text-sm text-slate-500">
              Sorularınız için: <a href="mailto:destek@himscharge.com" className="text-blue-400 hover:underline">destek@himscharge.com</a>
            </p>
          </div>

          {/* Back Link */}
          <div className="mt-6 pt-6 border-t border-slate-700">
            <Link 
              to="/technician" 
              className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Panele Dön
            </Link>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-slate-500 text-sm mt-6">
          © {new Date().getFullYear()} HIMS Charge. Tüm hakları saklıdır.
        </p>
      </div>
    </div>
  );
};

export default MembershipPaymentPage;
